import { useTranslation } from "react-i18next";
import type { AnalyticsSnapshotResponse } from "@/features/admin/adminAnalytics.types";
import { GenericAnalyticsTab } from "@/features/admin/components/analytics/GenericAnalyticsTab";

export function PqrSupportAnalyticsTab({ loading, snapshot }: { loading?: boolean; snapshot: AnalyticsSnapshotResponse | null }) {
  const { t } = useTranslation();
  return (
    <GenericAnalyticsTab
      loading={loading}
      panels={[
        { chart: "line", metricKey: "new_pqr_tickets", series: ["total"], title: t("adminWorkspace.analytics.pqr.ticketVolume") },
        { chart: "bar", metricKey: "new_pqr_tickets_by_category", series: ["bug_report", "feature_request", "billing_question", "account_issue", "content_question", "complaint", "other"], title: t("adminWorkspace.analytics.pqr.categories") },
      ]}
      snapshot={snapshot}
    />
  );
}
